<template>
<div class="position-relative">
    <!-- 발신번호 저장함 // 레이어팝업 -->
    <!-- <CallNumberBook :visible.sync="visible"></CallNumberBook> -->
    <!-- 발신번호 선택 컴포넌트 -->
    <div class="compo-form-item">
        <div class="compo-form-name">
            <label @click.prevent="toggleInfoBox" class="compo-form-title">발신번호<i class="required"></i><IconInfo></IconInfo></label>
            <a class="form-title-right" data-bs-toggle="collapse" href="#call-number-collapse" role="button" aria-expanded="false" aria-controls="call-number-collapse">
                <p class="txt-preview">
                    <span v-if="callNumber !== ''">{{callNumber}}</span>
                    <span v-else-if="chkflag === 'custom' && callNumber ===''">번호가 입력되지 않았습니다.</span>
                    <span v-else>{{selected}}</span>
                </p>
                <img class="collapse-icon" src="@/assets/img/icon_down.svg" alt="드롭다운 화살표">
                <!-- <button type="button" class="btn btn-popup" @click="handleClickButton">발신번호 저장함</button> -->
            </a>
        </div>
        <!-- 안내 문구 박스 -->
        <div v-show="activeInfo" class="info-box info-box_callnumber position-absolute">
            <IconClose @click.native="closeInfoBox" aria-label="닫기"></IconClose>
            <ul class="info">
                <li class="info-li"><span>행정, 공공, 금융기관 전화번호는 <strong>입력이 제한될 수 있습니다.</strong></span></li>
                <li class="info-li"><span> 번호변착방지서비스(특정인의 휴대번호를 임의로 발신자로 할 수 없음)에 가입된 경우 <strong>정상발송이 되지 않을 수 있습니다.</strong></span></li>
            </ul>
        </div>
        <div class="collapse" id="call-number-collapse">
            <div class="compo-form-body">
                <div class="choice-item">
                    <!-- <input type="radio" :value="`${callNumber}`" checked id="used" name="callNumber" v-model="callNumber"> -->
                    <input type="radio" class="buttonbox" checked id="used" name="callNumber" @click="clickCallNum" >
                    <label class="label-checkbox label-checkbox__order" for="used"  type="button" >
                        <span id="selected">{{selected}}</span>
                        <IconCheck></IconCheck>
                        <!-- 셀렉트 드롭다운 버튼 숨김처리 -->
                        <!-- <button id="selectBtn" class="select-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#call-select" aria-expanded="false" aria-controls="call-select">
                            <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M.894 0 0 .927 5 6.11l5-5.184L9.106 0 5 4.257.894 0z" fill="#989898"/>
                            </svg>
                        </button>
                        <div class="collapse label-select" id="call-select">
                            <div class="toggle-body">
                                <ul>
                                    <li id="selectDefault" v-on:click="selectSnderNo($event)">예스콘 고객센터 1588-5639</li>
                                    
                                    <li v-for = "(row, rowNum) in snderList" :key="rowNum">
                                        <div :id="`${rowNum}`" v-on:click="selectSnderNo($event)">{{row.snderNm}} {{row.snderNo}}</div>
                                    </li>
                                </ul>
                            </div>
                        </div> -->
                    </label>
                </div>
                <div class="choice-item">
                    <!-- <input type="radio" :value="`${callNumber}`" id="custom" name="callNumber" v-model="callNumber"> -->
                    <input type="radio" class="buttonbox" id="custom" name="callNumber" @click="clickCallNum">
                    <label class="label-checkbox label-checkbox__order" for="custom">
                        <span>직접입력</span>
                        <IconCheck></IconCheck>
                    </label>
                    <input type="tel" id="directlyInput" @click.prevent="directlyInput" class="form-control" placeholder="0000-0000" v-on:input='updateCallNum'>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    data() {
        return{
            selected: "예스콘 고객센터 1588-5639",
            snderNm: '',
            visible: false,
            callNumber: '',
            chkflag: 'used',
            compareSnderNo:[],
            activeInfo: false, // 인포박스 노출 여부
        }
    },

    components: {        
        // CallNumberBook: () => import('@/components/order-manager-layerpopup/CallNumberBook.vue'),     // 레이어 팝업
        IconInfo: () => import('@/components/svg-icon/IconInfo.vue'),                       // 인포메이션 아이콘
        IconClose: () => import('@/components/svg-icon/IconClose.vue'),                     // 닫기 아이콘
        IconCheck: () => import('@/components/svg-icon/IconCheck.vue'),                     // 체크 아이콘
    },

    computed: {
        ...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
            snderList: state => state.snderList,
            snderNo: state => state.snderNo,
            // tempExternalOrderMobile: state => state.tempExternalOrderMobile,
        }),
    },

    watch: {
        // 현재상품 리스트에서 불러온 경우
        // tempExternalOrderMobile(){
        //    this.$store.commit('setSnderNo','');
        //     if(this.tempExternalOrderMobile === '15885639') {
        //         this.selected = '예스콘 고객센터 1588-5639';
        //         this.$store.commit('setSnderNo', '15885639');
        //     } else {
        //         for(var i = 0; i<this.snderList.length; i++) { //불러온 발신자번호와 기존 저장된 발신자 번호와 일치하는 지 체크
        //             if(this.snderList[i].snderNo.replaceAll('-','') === this.tempExternalOrderMobile) {
        //                 this.$store.commit('setSnderNo',this.snderList[i].snderNo);
        //                 this.snderNm = this.snderList[i].snderNm;
        //             }
        //         }
        //         // 기존 저장된 발신번호랑 일치할 경우_this.snderNo가 존재
        //         if(this.snderNo) {
        //             this.selected = this.snderNm + ' ' + this.snderNo;
        //             // 발신번호 선택 후 셀렉트 바 및 화살표 원상복구
        //             document.getElementById('call-select').className = "collapse label-select";
        //             document.getElementById('selectBtn').ariaExpanded = "false";
        //             document.getElementById('selectBtn').className = "select-toggle collapsed";        
        //         } else { 
        //             document.getElementById('custom').checked = true;
        //             document.getElementById('directlyInput').value = this.tempExternalOrderMobile;
        //             this.callNumber = this.tempExternalOrderMobile;
        //             this.chkflag = 'custom';
        //         } 
        //     } 
        // }
    },

    methods: {
        getCookiesOrderData() {
            const isCookies = this.$cookies.isKey('cookiesOrderDataObj');

            if(isCookies) {
                const cookiesOrderDataObj = this.$cookies.get('cookiesOrderDataObj');
                const cookiesExternalOrderMobile = cookiesOrderDataObj.externalOrderMobile;

                if(cookiesExternalOrderMobile === '15885639') {
                    this.selected = '예스콘 고객센터 1588-5639';
                    this.$store.commit('setSnderNo', '15885639');
                } else {
                    // for(var i = 0; i<this.snderList.length; i++) { //불러온 발신자번호와 기존 저장된 발신자 번호와 일치하는 지 체크
                    //     if(this.snderList[i].snderNo.replaceAll('-','') === cookiesExternalOrderMobile) {
                    //         this.$store.commit('setSnderNo',this.snderList[i].snderNo);
                    //         this.snderNm = this.snderList[i].snderNm;
                    //     }
                    // }
                    // // 기존 저장된 발신번호랑 일치할 경우_this.snderNo가 존재
                    // if(this.snderNo) {
                    //     this.selected = this.snderNm + ' ' + this.snderNo;
                    //     // 발신번호 선택 후 셀렉트 바 및 화살표 원상복구
                    //     document.getElementById('call-select').className = "collapse label-select";
                    //     document.getElementById('selectBtn').ariaExpanded = "false";
                    //     document.getElementById('selectBtn').className = "select-toggle collapsed";        
                    // } else { 
                    //     document.getElementById('custom').checked = true;
                    //     document.getElementById('directlyInput').value = cookiesExternalOrderMobile;
                    //     this.callNumber = cookiesExternalOrderMobile;
                    //     this.chkflag = 'custom';
                    // }
                    document.getElementById('custom').checked = true;
                    document.getElementById('directlyInput').value = cookiesExternalOrderMobile;
                    this.callNumber = cookiesExternalOrderMobile;
                    this.chkflag = 'custom';
                }
            }
        },

        handleClickButton() { // 레이어 팝업 열기
            this.visible = !this.visible;
        },

        // 인포박스 노출
        toggleInfoBox(){
            this.activeInfo = !this.activeInfo;
        },

        // 인포박스 닫기
        closeInfoBox(){
            this.activeInfo = false;
        },

        directlyInput() { // 직접 입력 input 클릭 시 체크박스 동시에 선택
            document.getElementById('custom').checked = true;
        },

        selectSnderNo: function(event) {
            if (event.currentTarget.id == 'selectDefault') { // 선택된 값이 예스콘 고객센터 일 때 
                this.$store.commit('setSnderNo', "15885639");  
            } else {
                this.$store.commit('setSnderNo', this.snderList[event.currentTarget.id].snderNo.replaceAll('-',''));  
            }
            this.selected = document.getElementById(event.currentTarget.id).innerText;
            // 발신번호 선택 후 셀렉트 바 및 화살표 원상복구
            document.getElementById('call-select').className = "collapse label-select";
            document.getElementById('selectBtn').ariaExpanded = "false";
            document.getElementById('selectBtn').className = "select-toggle collapsed";
        },

        updateCallNum(event) {
            var updatedCallNum = event.target.value;
            this.callNumber = updatedCallNum;
        },

        clickCallNum(event) {
            if (event.currentTarget.id === 'used') { // 셀렉트 박스 체크
                document.getElementById('directlyInput').value = '';
                this.chkflag = 'used';
                this.callNumber = '';
            } else { // 직접입력 체크
                this.chkflag = 'custom';
            }
        }
    },

    mounted() {
        //  전체상품 임시저장에서 불러올 경우
        // if(this.tempExternalOrderMobile){
        //     this.$store.commit('setSnderNo','');
        //     if(this.tempExternalOrderMobile === '15885639') {
        //         this.selected = '예스콘 고객센터 1588-5639';
        //         this.$store.commit('setSnderNo', '15885639');    
        //     } else {
        //         for(var i = 0; i<this.snderList.length; i++) { //불러온 발신자번호와 기존 저장된 발신자 번호와 일치하는 지 체크
        //             if(this.snderList[i].snderNo.replaceAll('-','') === this.tempExternalOrderMobile) {        
        //                 this.$store.commit('setSnderNo',this.snderList[i].snderNo);
        //                 this.snderNm = this.snderList[i].snderNm
        //             } 
        //         }
        //         // 기존 저장된 발신번호랑 일치할 경우_this.snderNo가 존재
        //         if(this.snderNo) {
        //             this.selected = this.snderNm + ' ' + this.snderNo;
        //             // 발신번호 선택 후 셀렉트 바 및 화살표 원상복구
        //             document.getElementById('call-select').className = "collapse label-select";
        //             document.getElementById('selectBtn').ariaExpanded = "false";
        //             document.getElementById('selectBtn').className = "select-toggle collapsed";        
        //         } else { 
        //             document.getElementById('custom').checked = true;
        //             document.getElementById('directlyInput').value = this.tempExternalOrderMobile;
        //             this.callNumber = this.tempExternalOrderMobile;
        //             this.chkflag = 'custom';
        //         } 
        //     }          
        // }

        this.getCookiesOrderData();
    }
}
</script>


<style lang="scss" scoped>

@import '@/assets/css/order.scss';

.info-box_callnumber{
    @include info-box-position;

    @media (min-width: 768px) {
        top: -60px;
        left: 120px;
    }
}

.label-checkbox[for="used"]{ /* 발신번호 셀렉트 기능이 있는 체크박스(라디오버튼) */
    // width: 100%;
    justify-content: space-between;
    // >*:nth-child(2){
    //     margin-right: auto;
    // }
    // @media (min-width: 768px) {
    //     max-width: max-content;
    // }
}


</style>